import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout eyebrow="Legal" title="Cookie Notice" lastUpdated="December 2026">
      <p>
        This notice explains how Mackbe Tech Ltd uses cookies and similar
        technologies on this website, and the choices available to you under UK
        GDPR and PECR.
      </p>

      <h2>1. What are cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a
        website. They allow the site to remember your actions and preferences
        over a period of time.
      </p>

      <h2>2. Cookies we use</h2>
      <ul>
        <li>
          <strong>Strictly necessary</strong> — required for the site to function
          correctly (e.g. remembering your cookie preference).
        </li>
        <li>
          <strong>Analytics</strong> — help us understand how visitors interact
          with the site (page views, navigation paths). These are anonymised and
          used in aggregate.
        </li>
      </ul>

      <h2>3. Managing cookies</h2>
      <p>
        You can control cookies through your browser settings — most browsers
        allow you to refuse, accept, or delete cookies. Note that disabling
        certain cookies may affect site functionality.
      </p>

      <h2>4. Third-party services</h2>
      <p>
        Some pages may load content from third-party services (for example, our
        Cal.com booking widget). These services may set their own cookies which
        are governed by their respective privacy policies.
      </p>

      <h2>5. Updates</h2>
      <p>
        We may update this notice from time to time. The latest version will
        always be available on this page.
      </p>

      <h2>6. Contact</h2>
      <p>
        Questions about cookies: <a href="mailto:hello@mackbetech.com">hello@mackbetech.com</a>.
      </p>
    </LegalLayout>
  );
}
